import React, {ReactNode} from 'react';
import 'Shared/components/PagedView/Column.sass';
import {SharedColumnHeaderProps} from 'Shared/components/PagedView/Table/ColumnHeader';

export type ColumnProps<TData, TFilter> = {
  dataItem: TData;
  visible?: () => boolean;
  children: (value: TData) => ReactNode;
  allowHide?: boolean;
  default?: boolean;
  isActions?: boolean;
} & SharedColumnHeaderProps<TFilter, TData>;

export const Column = <TData, TFilter>(props: ColumnProps<TData, TFilter>) => {
  const {children, dataItem} = props;

  return <>{children(dataItem)}</>;
};

export default Column;
